"use client";

import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { useLenis } from "lenis/react";
import { AnimatePresence, motion } from "framer-motion";
import { cn } from "@/lib/utils";

export function ScrollToTop({ className }: { className?: string }) {
  const [visible, setVisible] = useState(false);
  const lenis = useLenis();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTop = () => {
    if (lenis) {
      lenis.scrollTo(0, { duration: 1.1 });
      return;
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <AnimatePresence>
      {visible ? (
        <motion.button
          type="button"
          initial={{ opacity: 0, y: 12, scale: 0.92 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 10, scale: 0.92 }}
          transition={{ duration: 0.2 }}
          onClick={goTop}
          aria-label="Back to top"
          title="Back to top"
          className={cn(
            "fixed z-[70] inline-flex h-12 w-12 items-center justify-center rounded-full border border-border-strong",
            "bottom-[calc(max(1rem,env(safe-area-inset-bottom))+3.85rem)] right-[max(1rem,env(safe-area-inset-right))]",
            "bg-foreground text-background shadow-[var(--shadow-soft)]",
            "transition hover:opacity-90 sm:bottom-[calc(1.25rem+4.25rem)] sm:right-5",
            className,
          )}
        >
          <ArrowUp className="h-5 w-5" strokeWidth={2.25} />
        </motion.button>
      ) : null}
    </AnimatePresence>
  );
}
